import React from 'react';

import { Tabs, Tab } from '../../../../components/Tabs';
import NiokrTab from '../../../../components/Portfolio/Widgets/Requests/NiokrTab';
import RidTab from '../../../../components/Portfolio/Widgets/Requests/RidTab';
import HintCard from '../../../../components/common/HintCard/HintCard';

const tabs = [
  {
    label: 'NIOKR',
    tabName: 'Заявки на НИОКР',
    content: NiokrTab,
  },
  {
    label: 'RID',
    tabName: 'Заявки на РИД',
    content: RidTab,
  },
];

export default function PortfRequests({ portfName }) {
  return (
    <div style={{ color: 'black' }}>
      <HintCard
        cardStyles={{ fontSize: '18px', marginTop: 0, fontsize: '18px' }}
        noGutter
        rowStyles={{ padding: 0, margin: 'auto', marginBottom: '1em' }}
        text="Для добавления статей/доходов/заявок в проект, убедитесь, что заполнен реестр «Участники»"
      />
      <Tabs>
        {tabs.map((tab, i) => (
          <Tab key={i} label={tab.label} tabName={tab.tabName}>
            <tab.content portfName={portfName} />
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}
